<template>
  <div id="map-navigation-elements">
    <div
      :class="{ disableMapButton: tool.disabled }"
      :key="tool.eventName"
      class="map-tool"
      v-for="tool in buttons"
      :style="{
        right: tool.rightPosition + 'px',
        bottom: tool.bottomPosition + 'px'
      }"
      @click="$emit(tool.eventName)"
    >
      <v-icon :color="tool.selected ? 'accent' : '#767676'" size="20">
        {{ tool.icon }}
      </v-icon>
      <md-tooltip :md-direction="tool.tooltipPosition" class="app-tooltip">
        {{ tool.tooltipLabel }}
      </md-tooltip>
    </div>
  </div>
</template>

<script>
import { checkPermissionsMixin } from "@/mixins/checkPermissionsMixin";
import SatelliteSVG from "@/assets/map_icons/satellite.svg";
import MapSVG from "@/assets/map_icons/map.svg";

export default {
  name: "MapNavigationElements",

  components: {
    SatelliteSVG,
    MapSVG
  },

  mixins: [checkPermissionsMixin],

  props: {
    showStreetView: {
      type: Boolean
    }
  },

  computed: {
    buttons() {
      return [
        {
          eventName: "forceWorkspaceFilter",
          rightPosition: "10",
          bottomPosition: "105",
          icon: "layers_clear",
          tooltipLabel: this.$i18n.t("FilterObjectsByWorkspace"),
          tooltipPosition: "top",
          selected: !this.$store.getters.getForceWorkspaceFilter,
          disabled: !this.isAdmin && !this.isSuperAdmin
        },
        {
          eventName: "toggleStreetView",
          rightPosition: "50",
          bottomPosition: "105",
          icon: "mdi-google-street-view",
          tooltipLabel: this.$i18n.t("ToggleStreetView"),
          tooltipPosition: "top",
          selected: this.showStreetView,
          disabled: false
        },
        {
          eventName: "centerWorkspace",
          rightPosition: "90",
          bottomPosition: "85",
          icon: "location_searching",
          tooltipLabel: this.$i18n.t("CenterWorkspace"),
          tooltipPosition: "left",
          disabled: false
        },
        {
          eventName: "zoomIn",
          rightPosition: "105",
          bottomPosition: "45",
          icon: "zoom_in",
          tooltipLabel: this.$i18n.t("ZoomIn"),
          tooltipPosition: "left",
          disabled: false
        },
        {
          eventName: "zoomOut",
          rightPosition: "105",
          bottomPosition: "5",
          icon: "zoom_out",
          tooltipLabel: this.$i18n.t("ZoomOut"),
          tooltipPosition: "left",
          disabled: false
        }
      ];
    }
  }
};
</script>

<style scoped>
#map-navigation-elements {
  position: absolute;
  right: 0;
  bottom: 0;
}

.map-tool {
  width: 32px;
  height: 32px;
  margin: 5px;
  background-color: white;
}

.disableMapButton {
  pointer-events: none;
  opacity: 0.5;
}

.mapTypePickerSVG > path {
  fill: var(--v-secondary-base) !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Home/Content/NavigationElements.vue